export const environment = {
  production: true,
  url: "/timesheet-api"

};
